<div class="container">
  <!-- Hero Banner -->
  <app-hero-banner
    [title]="'excellence in every detail'"
    [isFullBanner]="true"
    [imgPath]="'../../../assets/hi-res/hero.png'"
  ></app-hero-banner>

  <!-- About -->
  <!-- TODO: class removed because of midway  bug -->
  <!-- hidden -->
  <div class="about-container fade-in">
    <h1>about bourne bespoke</h1>

    <p>
      Following an established career in large scale property development and
      global exhibition stand design; Bourne Bespoke specialises in unique home
      enhancement creations - designed, procured, built and installed by a
      passionate craftsman - with the perfect balance of form and function. An
      ambitiously efficient one-stop solution for residential clients, interior
      designers, property developers and the commercial / hospitality sector.
    </p>
  </div>

  <!-- Creations -->
  <!-- TODO: class removed because of scroll bug, fix! -->
  <!-- hidden -->
  <div class="creations-container slide-in-up">
    <div class="title">
      <h1>creations</h1>
      <h2>our five core categories</h2>
    </div>
    <div class="creations">
      @for (creation of creations; track $index) {
      <div class="creation" (click)="navigateToCreations(creation.title)">
        <img [src]="creation.src" [alt]="creation.title" />
        <div class="creation-title">
          <h2>{{ creation.title }}</h2>
          <i class="fa-solid fa-chevron-right"></i>
        </div>
      </div>
      }
    </div>
  </div>

  <!--  Banner -->
  <!-- Hidden -->
  <div class="banner-container fade-in">
    <div class="banner">
      <div class="banner-overlay"></div>
      <div class="overlay-text">
        <h2 class="hero-text">Let's Talk About Your Vision</h2>
        <h1 class="hero-text">Get in Touch with Us Today</h1>
        <p>
          Whether you have questions or are ready to start planning your next
          project, we’re here to provide guidance, expertise, and support. Our
          team is ready to turn your vision into reality with precision and
          attention to detail.
        </p>

        <a routerLink="/contact-us" aria-label="Contact us for a quote">
          <button class="cta-button">Contact Us</button>
        </a>
      </div>
    </div>
  </div>
  <!-- Footprint maps -->
  <!-- Hidden -->
  <div class="footprint-container slide-in-up">
    <div class="text">
      <h2>Our Craftsmanship</h2>
      <h1>Discover Our Footprint</h1>
      <p>
        We work with clients across the UK. Each project reflects our unwavering
        commitment to excellence and attention to detail.
      </p>
    </div>
    <div class="maps">
      <img src="../../assets/hi-res/map.png" alt="" />
      <!-- <google-map height="600px" width="600px" [options]="options">
        @for (position of markerPositions; track trackByPosition ) {
        <ng-container>
          <map-advanced-marker
            [position]="position"
            [options]="markerOptions[$index]"
          ></map-advanced-marker>
        </ng-container>
        }
      </google-map> -->
    </div>
  </div>
  <!-- Clients -->
  <!-- <div class="clients-container" style="margin-bottom: 20px">
    <h1>featured clients</h1>
    <div class="clients-wrapper" #clientContainer>
      <div class="clients">
        @for (logo of logos; track $index) {
        <img [src]="logo.url" alt="Client Logo {{ $index }}" />
        }
      </div>
    </div>
  </div> -->
</div>
